const marketing = [
  {
    path: '/marketing/support-discount',
    name: 'support-discount-code',
    component: () => import('@/views/marketing/SupportDiscountCode.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_low_privileged_discount_code',
      resource: 'all',
    },
  },
  {
    path: '/marketing/discount',
    name: 'discount-code',
    component: () => import('@/views/marketing/DiscountCode.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_discount_code',
      resource: 'all',
    },
  },
  {
    path: '/marketing/setting',
    name: 'setting',
    component: () => import('@/views/marketing/SettingDiscounts.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_marketing_setting',
      resource: 'all',
    },
  },
  {
    path: '/marketing/short-link',
    name: 'short-link',
    component: () => import('@/views/marketing/ShortLink.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_short_links',
      resource: 'all',
    },
  },
  {
    path: '/login_notice',
    name: 'login-notice',
    component: () => import('@/views/marketing/loginNotice/index.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_login_popup',
    },
  },
  {
    path: '/login_notice/create',
    name: 'login-notice-create',
    component: () => import('@/views/marketing/loginNotice/create.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_login_popup',
    },
  },
  {
    path: '/login_notice/edit/:id',
    name: 'login-notice-edit',
    component: () => import('@/views/marketing/loginNotice/edit.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_login_popup',
    },
  },
]

export default marketing
